import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { InternalReportService } from 'src/app/shared/services/API/business-intelligence/internal-report.service';

@Component({
  selector: 'app-internal-report-delete-modal',
  templateUrl: './internal-report-delete-modal.component.html',
  styleUrls: ['./internal-report-delete-modal.component.css']
})
export class InternalReportDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<InternalReportDeleteModalComponent>,
    private internalReportService: InternalReportService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteInternalReport: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.internalReportService.deleteInternalReport(this.data.idInternalReport).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Relatório interno excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteInternalReport: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteInternalReport: false}); 
  }
}